import { _mutations } from './mutation-types'

export default {
  [_mutations.SET_ERROR] (state, error) {
    state.error = error
  }
}
